/* import __COLOCATED_TEMPLATE__ from './bulk-tagging-dependencies-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();